<template>
  <main>
    <div style="background-color: white">
      <div class="showUs">
        <div class="content">
          <div>
            <div class="icon">
              <img src="@/assets/images/Home/start-3.png">
              <span>{{ $t('services.exchange.icon') }}</span>
            </div>

            <div class="textContent">
              <div>
                <h3>{{ $t('services.exchange.heroTitle') }}</h3>
                <p v-html="$t('services.exchange.heroBody')"></p>
                <div class="action">
                  <a class="button" :href="`${this.clientUrl}/auth/register`" target="_blank">
                    <span>{{ $t('common.startNow') }}</span>
                    <div class="arrowBox">
                      <span class="arrow">
                        <i /><i /><i />
                      </span>
                    </div>
                  </a>
                  <router-link class="button" to="/customer" target="_blank">
                    <span>{{ $t('common.contactUs') }}</span>
                    <span class="arrow">
                      <i /><i /><i />
                    </span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <div class="images">
            <img src="@/assets/images/Services/exchange/point.png">
            <img src="@/assets/images/Services/exchange/exchange-1.png">
            <img src="@/assets/images/Services/exchange/exchange-2.png">
          </div>
        </div>
      </div>

      <div class="experience content">
        <div class="textAndList">
          <h3>{{ $t('services.exchange.experienceTitle') }}</h3>
          <p v-html="$t('services.exchange.experienceBody')"></p>

          <ul>
            <li v-for="(item, index) in experienceItems" :key="item.title">
              <img :src="experienceIcons[index]" alt="Open" />
              <span>{{ item.title }}</span>
              <p v-html="item.desc"></p>
            </li>
          </ul>
        </div>

        <div class="images">
          <img src="@/assets/images/Services/exchange/experience.png"/>
        </div>
      </div>

      <div class="rate content">
        <div class="textAndList">
          <h3>{{ $t('services.exchange.rateTitle') }}</h3>
          <p v-html="$t('services.exchange.rateBody')"></p>
          <ul>
            <li v-for="(item, index) in rateItems" :key="item.title">
              <img :src="rateIcons[index]" alt="rate" />
              <span>{{ item.title }}</span>
              <p v-html="item.desc"></p>
            </li>
          </ul>
        </div>

        <div class="images">
          <img src="@/assets/images/Services/exchange/rate.png">
        </div>
      </div>

      <div class="tool content">
        <div class="textAndList">
          <h3>{{ $t('services.exchange.toolTitle') }}</h3>
          <p v-html="$t('services.exchange.toolBody')"></p>
          <ul>
            <li v-for="(item, index) in toolItems" :key="item.title">
              <img :src="toolIcons[index]" alt="Open" />
              <span>{{ item.title }}</span>
              <p v-html="item.desc"></p>
            </li>
          </ul>
        </div>

        <div class="images">
          <img src="@/assets/images/Services/exchange/tool.png">
        </div>
      </div>

      <div class="process">
        <div class="content">
          <div class="textAndList">
            <h3>{{ $t('services.exchange.processTitle') }}</h3>
            <p v-html="$t('services.exchange.processBody')"></p>

            <ul>
              <li v-for="(item, index) in processItems" :key="item.title">
                <img :src="processIcons[index]" alt="delivery" />
                <span>{{ item.title }}</span>
                <p v-html="item.desc"></p>
              </li>
            </ul>
          </div>
          <div>
            <img src="@/assets/images/Payment/register1.png">
            <img src="@/assets/images/Payment/register2.png">
          </div>

        </div>
      </div>
    </div>
  </main>
</template>

<script>
  export default {
    name: 'Acquiring',
    data() {
      return {
        stopSrc: '',
        height: window.innerHeight,
        experienceIcons: [
          require('@/assets/images/Services/account-2.png'),
          require('@/assets/images/Services/experience-1.png'),
        ],
        rateIcons: [
          require('@/assets/images/Services/rate-1.png'),
          require('@/assets/images/Services/rate-2.png'),
        ],
        toolIcons: [
          require('@/assets/images/Services/tool-1.png'),
          require('@/assets/images/Services/tool-2.png'),
        ],
        processIcons: [
          require('@/assets/images/Services/open-1.png'),
          require('@/assets/images/Services/transaction.png'),
          require('@/assets/images/Services/delivery.png'),
        ],
      }
    },
    computed: {
      experienceItems() {
        return this.$t('services.exchange.experienceItems');
      },
      rateItems() {
        return this.$t('services.exchange.rateItems');
      },
      toolItems() {
        return this.$t('services.exchange.toolItems');
      },
      processItems() {
        return this.$t('services.exchange.processItems');
      },
    },
    mounted() {

    },
    destroyed() {
      window.onresize = null;
    }
  }
</script>

<style lang="less" scoped>
  .bodyFont(@bodyFontSize: 18px, @bodyLineHeight: 1.555555556, @fontWeightNormal: 300) {
    font: @fontWeightNormal @bodyFontSize/@bodyLineHeight "sohne-var", "Helvetica Neue", "Arial", sans-serif;
  }

  .button {
    height: auto;
    padding: 3px 0 6px;
    line-height: 1.6;
    .bodyFont(15px, 1.6, 425);
  }

  .showUs {
    background: #F6F9FC;
    padding: 112px 0 72px;
    .content {
      min-height: 577px;
      & > div {
        .icon {
          display: flex;
          align-items: center;
          height: 52px;
          & > img {
            width: 52px;
            margin-right: 20px;
          }
          & > span {
            display: flex;
            justify-content: center;
            font-size: 18px;
            font-weight: 500;
            color: #082440;
            line-height: 27px;
          }
        }

        .textContent {
          display: flex;

          & > div {
            width: 560px;
            margin-top: 72px;
            & > h3 {
              max-width: 520px;
              font-size: 48px;
              font-weight: 500;
              color: #082440;
              line-height: 58px;
            }

            & > p {
              width: 500px;
              margin-top: 30px;
              color: #082440;
              font-weight: 200;
              font-size: 20px;
              line-height: 36px;
              & > span {
                color: var(--spanColor1);
              }
            }

            .action {
              display: flex;
              margin-top: 30px;
              .button {
                width: 122px;
                margin-right: 20px;
                background: #0070FF;

                &:first-child:hover {
                  background: #0A2540;
                }

                &:last-child {
                  width: auto;
                  background: none;
                  color: #0070FF;

                  .arrow > i {
                    background: #0070FF;
                  }
                }
              }
            }
          }
        }
      }

      .images {
        position: absolute;
        right: -40px;
        top: 132px;
        transform: scale(0.9);
        transform-origin: top right;
        & > img {
          height: 516px;
          &:nth-child(2) {
            position: absolute;
            height: 464px;
            top: -65px;
            left: 93px;
            border-radius: 20px;
            box-shadow: 0px 40px 80px -20px rgba(21, 21, 46, 0.32);
          }
          &:last-child {
            position: absolute;
            height: 690px;
            top: 91px;
            left: -135px;
          }
        }
      }

    }
  }

  .textAndList {
    & > span {
      font-size: 36px;
      font-weight: 400;
      color: #082440;
      line-height: 54px;
    }
    & > p {
      width: 480px;
      font-size: 20px;
      font-weight: 200;
      color: #092641;
      line-height: 36px;
      & > span {
        color: var(--spanColor1);
      }
    }

    & > ul {
      display: flex;
      padding: 0;
      margin-top: 59px;
      & > li {
        margin-right: 55px;
        & > img {
          height: 40px;
        }

        & > span {
          display: block;
          position: relative;
          font-size: 16px;
          font-weight: bold;
          color: #082440;
          line-height: 16px;
          margin-top: 20px;

          &:before {
            position: absolute;
            left: -15px;
            width: 1px;
            height: 15px;
            content: '';
            background: #0070FF;
          }
        }
        & > p {
          width: 240px;
          font-size: 16px;
          font-weight: 200;
          color: #092641;
          line-height: 24px;
          margin-top: 10px;
          & > span {
            color: var(--spanColor1);
          }
        }
      }
    }
  }

  .experience {
    padding: 120px 0 0 0;
    display: flex;
    justify-content: space-between;
    .textAndList {
      margin-top: 21px;
    }
    .images {
      position: relative;
      margin-right: -50px;

      & > img {
        height: 392px;
        border-radius: 20px;
        box-shadow: 0px 40px 80px -20px rgba(21, 21, 46, 0.32);
      }
    }
  }

  .showFeatures {
    display: flex;
    justify-content: space-between;
    & > div {
      margin-top: 43px;
      & > span {
        font-size: 28px;
        font-weight: 400;
        color: #0070FF;
        line-height: 41px;
        margin-bottom: 13px;
      }
      & > p {
        width: 480px;
        font-size: 20px;
        font-weight: 200;
        color: #092641;
        line-height: 36px;
        margin-bottom: 30px;
        & > span {
          color: #0070FF;
          font-weight: 400;
        }
      }
      & > ul {
        list-style: none;
        & > li {
          display: flex;
          align-items: center;
          font-size: 20px;
          font-weight: 200;
          color: #092641;
          line-height: 29px;
          margin-bottom: 12px;
          & > div {
            border: 3px solid rgba(83, 226, 177, 0.33);
            border-radius: 8px;
            margin-right: 10px;
            & > div {
              padding: 3px;
              background: #0BEA82;
              border-radius: 8px;
            }
          }
        }
      }
    }
    & > img {
      width: 592px;
      border-radius: 20px;
      box-shadow: 0px 40px 80px -20px rgba(21, 21, 46, 0.32), 0px -3px 8px 0px rgba(149, 161, 173, 0.75) inset;
    }
  }
  .rate {
    padding: 217px 0 0 0;
    display: flex;
    justify-content: space-between;

    .images {
      position: relative;
      margin-right: -50px;
      & > img {
        height: 390px;
        margin-top: 16px;
        border-radius: 20px;
        box-shadow: 0px 40px 80px -20px rgba(21, 21, 46, 0.32);
      }
    }
  }

  .tool {
    padding: 166px 0 200px 0;
    display: flex;
    justify-content: space-between;
    .textAndList {
      margin-top: 29px;
    }
    .images {
      position: relative;
      margin-right: -50px;
      & > img {
        height: 391px;
        border-radius: 16px;
        box-shadow: 0px 40px 80px -20px rgba(21, 21, 46, 0.32);
      }
    }
  }

  .process {
    padding: 142px 0 0;
    background: #F6F9FC;
    overflow: hidden;
    .content {
      display: flex;
      justify-content: space-between;
      & > div {
        position: relative;
        right: 0;
        bottom: -20px;
        & > img {
          width: 296px;
          border-radius: 12px;
          box-shadow: 0px 40px 80px -20px rgba(21, 21, 46, 0.32), 0px -3px 8px 0px rgba(149, 161, 173, 0.75) inset;
          &:last-child {
            position: absolute;
            top: 57px;
            left: 47px;
          }
        }
      }
    }
  }

  @media screen and (max-width: 1000px) {
    .showUs {
      padding: 72px 0 40px;

      .content {
        min-height: auto;
        padding: 0 20px;
        display: flex;
        flex-direction: column;
      }

      .content > div .textContent > div {
        width: auto;
        margin-top: 24px;

        & > h3 {
          max-width: none;
          font-size: 32px;
          line-height: 44px;
        }

        & > p {
          width: auto;
          max-width: none;
          font-size: 18px;
          line-height: 30px;
        }
      }

      .images {
        transform: none;
        position: relative;
        right: auto;
        top: auto;
        margin: 24px 0 0;
        align-self: center;
      }
    }

    .experience,
    .rate,
    .tool,
    .process {
      padding-left: 20px;
      padding-right: 20px;
    }

    .experience,
    .rate,
    .tool {
      padding-top: 120px;
      align-items: center;
      gap: 32px;

      .textAndList {
        margin-top: 0;
      }

      .images {
        margin-right: 0;
        flex: 1;
        min-width: 0;

        & > img {
          width: 100%;
          height: auto;
          max-width: 592px;
        }
      }
    }

    .textAndList {
      flex: 1;

      & > h3,
      & > span {
        font-size: 30px;
        line-height: 40px;
      }

      & > p {
        width: 100%;
        max-width: 560px;
        font-size: 18px;
        line-height: 30px;
      }

      & > ul {
        flex-wrap: wrap;
        gap: 24px 0;

        & > li {
          width: 50%;
          margin-right: 0;
          padding-right: 24px;

          & > p {
            width: auto;
          }
        }
      }
    }

    .process {
      padding-top: 120px;

      .content {
        gap: 32px;
        align-items: flex-start;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .showUs {
      padding: 40px 16px 20px;
      overflow: hidden;

      .content {
        min-height: auto;
        padding: 0;

        & > div:first-child {
          width: 100%;
          min-width: 0;

          .icon {
            height: auto;
            justify-content: center;
            margin-bottom: 0;

            & > img {
              width: 32px;
              margin-right: 8px;
            }

            & > span {
              font-size: 14px;
              line-height: 20px;
            }
          }

          .textContent {
            display: block;
            width: 100%;

            & > div {
              width: 100%;
              margin-top: 24px;

              & > h3 {
                max-width: none;
                margin-bottom: 10px;
                font-size: 24px;
                line-height: 1.25;
                text-align: center;
              }

              & > p {
                width: auto;
                max-width: none;
                margin-top: 0;
                margin-bottom: 20px;
                font-size: 15px;
                line-height: 1.6;
                text-align: left;
              }

              .action {
                flex-direction: column;
                align-items: center;
                gap: 12px;
                margin-top: 0;

                .button {
                  width: 100%;
                  max-width: 320px;
                  margin: 0;

                  &:last-child {
                    width: 100%;
                    max-width: 320px;
                  }
                }
              }
            }
          }
        }
      }

      .images {
        display: none;
      }
    }

    .experience,
    .rate,
    .tool,
    .process {
      padding-left: 16px;
      padding-right: 16px;
    }

    .experience,
    .rate,
    .tool {
      flex-direction: column;
      gap: 24px;
      padding-top: 88px;
    }

    .tool {
      padding-bottom: 96px;
    }

    .textAndList {
      & > h3,
      & > span {
        font-size: 26px;
        line-height: 34px;
      }

      & > p {
        font-size: 16px;
        line-height: 28px;
      }

      & > ul {
        margin-top: 32px;
        gap: 20px;

        & > li {
          width: 100%;
          padding-right: 0;

          & > span {
            margin-top: 16px;
          }
        }
      }
    }

    .process {
      padding-top: 88px;

      .content {
        flex-direction: column;
        gap: 24px;

        & > div:last-child {
          width: 100%;
          padding-bottom: 180px;

          & > img {
            width: 72vw;
            max-width: 296px;

            &:last-child {
              left: auto;
              right: 0;
              top: 42px;
            }
          }
        }
      }
    }
  }
</style>
